// Enhanced API Service
// This service extends the base API with enhanced jewelry functionality

import api from './api';

class ApiService {
  // Vendor methods
  async getVendors() {
    return api.getVendors();
  }

  async createVendor(data) {
    return api.createVendor(data);
  }

  // Category methods  
  async getCategories() {
    return api.getCategories();
  }

  // Jewelry methods
  async getJewelry(params = {}) {
    return api.getJewelry(params);
  }

  // Enhanced inventory item creation - maps to createJewelry
  async addInventoryItem(inventoryData) {
    // Map inventory data to jewelry schema
    const jewelryData = {
      code: inventoryData.code || inventoryData.item_number,
      name: inventoryData.name || inventoryData.description || 'Jewelry Item',
      description: inventoryData.description,
      category_id: inventoryData.category_id,
      vendor_id: inventoryData.vendor_id,
      
      // Weight fields
      gross_weight: inventoryData.gross_weight || inventoryData.grossWeight,
      net_weight: inventoryData.net_weight || inventoryData.netWeight,
      gold_weight: inventoryData.gold_weight || inventoryData.netWeight, // Use net weight as gold weight if not specified
      stone_weight: inventoryData.stone_weight || inventoryData.stoneWeight,
      
      // Gold details
      gold_purity: this.convertPurityToNumeric(inventoryData.gold_purity || inventoryData.purity),
      gold_rate: inventoryData.gold_rate || inventoryData.goldRate,
      total_gold_price: inventoryData.total_gold_price || inventoryData.totalGoldPrice,
      
      // Cost calculations
      total_stone_cost: inventoryData.total_stone_cost || 0,
      wastage_percentage: inventoryData.wastage_percentage || inventoryData.wastagePercentage || 0,
      total_wastage: inventoryData.total_wastage || 0,
      making_charges: inventoryData.making_charges || inventoryData.makingCharges || 0,
      labor_charges: inventoryData.labor_charges || inventoryData.laborCharges || 0,
      other_costs: inventoryData.other_costs || inventoryData.otherCosts || 0,
      total_making_charges: inventoryData.total_making_charges || inventoryData.makingCharges || 0,
      total_cost_value: inventoryData.total_cost_value || inventoryData.totalCostValue || (
        (inventoryData.total_gold_price || inventoryData.totalGoldPrice || 0) +
        (inventoryData.making_charges || inventoryData.makingCharges || 0) +
        (inventoryData.labor_charges || inventoryData.laborCharges || 0) +
        (inventoryData.other_costs || inventoryData.otherCosts || 0)
      ),
      
      // Kundan/fine fields
      fine_percentage: inventoryData.fine_percentage,
      kundan_weight: inventoryData.kundan_weight,
      kundan_percentage: inventoryData.kundan_percentage,

      // Pricing
      sale_price: inventoryData.sale_price || inventoryData.salePrice || 0,

      // Stones data - CRITICAL MISSING MAPPING
      stones: inventoryData.stones || [],

      // Other fields
      certificate: inventoryData.certificate === 'Yes' ? 'Yes' : 'No',
      status: inventoryData.status || 'In Stock',
      notes: inventoryData.notes || `Pieces: ${inventoryData.pcs || 1}`
    };

    return api.createJewelry(jewelryData);
  }

  // Helper method to convert purity strings to numeric values
  convertPurityToNumeric(purity) {
    if (typeof purity === 'number') return purity;
    
    const purityMap = {
      '14KT': 14,
      '18KT': 18,
      '22KT': 22,
      '24KT': 24,
      '14K': 14,
      '18K': 18, 
      '22K': 22,
      '24K': 24
    };
    
    return purityMap[purity] || 22; // Default to 22KT
  }

  // Gold rate methods
  async getCurrentGoldRate() {
    return api.getCurrentGoldRate();
  }

  // Search methods
  async searchJewelry(searchTerm, params = {}) {
    return api.searchJewelry(searchTerm, params);
  }

  // Statistics
  async getJewelryStatistics() {
    return api.getJewelryStatistics();
  }

  // Estimates
  async createEstimate(data) {
    return api.createEstimate(data);
  }

  async getEstimates() {
    return api.getEstimates();
  }

  // Upload methods
  async bulkUploadJewelry(items) {
    return api.bulkUploadJewelry(items);
  }

  // Materials
  async getMaterials() {
    return api.getMaterials();
  }
}

// Export singleton instance
const apiService = new ApiService();
export default apiService;